import React, { useState } from "react";
import CompanyTeamMembers from "./CompanyTeamMembers";
import TeamPermissions from "./TeamPermissions";
import { toggleModal } from "../../../../reducers/modalReducer";
import { useSelector, useDispatch } from "react-redux";

export default function TeamTabs({ company, teamMembers, setEditUser, setUserAction, resendInviteMember, handleDeleteMember }) {
    let user = useSelector((state) => state.user);
    let [teamTab, setTeamTab] = useState("Team Members");
    let dispatch = useDispatch();

    return (
        <>
            <div className='dashboard-tools-area'>
                <div className='box-dashbord-container mla mra mb6rem'>
                    <div className='tabs-navlist tabs-dashboard df aic jcc mt2rem mb2rem'>
                        {['Team Members', 'Team Permissions'].map(item => {
                            return <div className="df fdc">
                                <button className={`13 fs1-25rem fw500 c15 cp ${teamTab == item && ' active'}`} onClick={() => setTeamTab(item)}>{item}</button>
                            </div>
                        })
                        }
                    </div>

                    {(user['role'] !== 'Advisor' && user['role'] !== 'Investor') &&
                        <div className="df fdc mr2rem">
                            <div className="df">
                                <div className="df bg1 br50px mr0-5rem pr1rem p0-5rem bsbb aic mr1rem cp add-btn-dashboard" onClick={() => { setEditUser({}); dispatch(toggleModal({ open: 'editUser' })); setUserAction('Search'); }}>
                                    <span className='bg1 bsbb p0-5rem mr0-5rem br100 w40px h40px tac df jcc aic'>
                                        <svg className='h30px w30px' width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_2656_879)">
                                                <path d="M19 0C8.52298 0 0 8.52298 0 19C0 29.477 8.52298 38 19 38C29.477 38 38 29.477 38 19C38 8.52298 29.477 0 19 0Z" fill="#4A67FF" />
                                                <path d="M27.3098 20.5825H20.5805V27.3118C20.5805 28.1859 19.8714 28.895 18.9973 28.895C18.1232 28.895 17.4141 28.1859 17.4141 27.3118V20.5825H10.6848C9.8107 20.5825 9.10156 19.8734 9.10156 18.9993C9.10156 18.1252 9.8107 17.416 10.6848 17.416H17.4141V10.6868C17.4141 9.81265 18.1232 9.10352 18.9973 9.10352C19.8714 9.10352 20.5805 9.81265 20.5805 10.6868V17.416H27.3098C28.1839 17.416 28.893 18.1252 28.893 18.9993C28.893 19.8734 28.1839 20.5825 27.3098 20.5825Z" fill="#FAFAFA" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_2656_879">
                                                    <rect width="38" height="38" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </span>
                                    <span className='c15'>Add to team</span>
                                </div>
                            </div>
                        </div>}


                    {teamTab == 'Team Members' && <CompanyTeamMembers company={company} teamMembers={teamMembers} setEditUser={setEditUser} setUserAction={setUserAction} resendInviteMember={resendInviteMember} handleDeleteMember={handleDeleteMember} />}
                    {teamTab == 'Team Permissions' && <TeamPermissions company={company} setEditUser={setEditUser} setUserAction={setUserAction} />}
                </div>
            </div>


        </>
    );
};
